import React from "react";
import { useRazorpay } from "../../../../context/RazorpayContext";

const AddonPreviewModal = ({ accountType, setShowPage, onCancelPaymentNavigationUrl }) => {

  const {
    addonInvoicePreviewData,
    handleAddOnSellerAccount,
    onCloseAddOnInvoicePreview
  } = useRazorpay();

  if (!addonInvoicePreviewData?.isOpenModal) return null;
  

  // const packangeName = addonInvoicePreviewData?.previewData?.to_package;
  const planPrice = addonInvoicePreviewData?.previewData?.amount;

  const handleSubmitArgument = () => {
    if (accountType === 'amazonAds') {
      return { type: 'amazonAds', action: setShowPage }
    }
    return null
  }

  return (
    <>
      <div className="modal d-flex align-items-center justify-content-center package_summary_overlay">
        <div className="modal-dialog animate__animated animate__zoomIn" style={{ maxWidth: "550px", width: "100%", margin: "auto" }}>
          <div className="modal-content border-0 gapalyze-modal shadow">

            {/* Body */}
            <div className="modal-body px-4 pt-3 pb-2">
              {/* Modal cross button */}
              <button
                className="package-summary-cross-icon"
                type="button"
                disabled={addonInvoicePreviewData?.isLoading}
                onClick={(e) => onCloseAddOnInvoicePreview(e, onCancelPaymentNavigationUrl)}
              >
                <i className="bi bi-x-lg"></i>
              </button>
              <div className="d-flex mb-2 align-items-center">
                <div className="gapalyze-logo-box">
                  <span className="fw-bold gapalyze-text-primary" style={{ fontSize: '20px' }}>G</span>
                </div>
                <div>
                  <h5 className="mb-0 fs-6 fw-bold gapalyze-text-dark text-capitalize">
                    Add On Accounts
                  </h5>
                </div>
              </div>

              {/* Timeline */}
              <div className="mb-2 mt-4">
                {addonInvoicePreviewData?.previewData?.accounts.map((item, index) => (
                  <div className="" key={index}>

                    <div className="mb-2 d-flex justify-content-between align-items-start">
                      {/* LEFT */}
                      <div>
                        <span className="d-block gapalyze-text-dark fw-medium" style={{ fontSize: '14px' }}>
                          {item.name}
                        </span>
                      </div>

                      {/* RIGHT */}
                      <div className="text-end">
                        <span className="d-block gapalyze-text-dark fw-bold" style={{ fontSize: '14px' }}>

                          {/* Show original price if discount */}
                          {item.amount}/{item?.interval}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <hr className="my-1" style={{ borderColor: '#dadce0', opacity: 1 }} />
              <div className="d-flex justify-content-between align-items-center">
                <div className="py-2 small text-dark fw-semibold">
                  Total Amount
                </div>
                <div className="py-1 small text-end fw-bold text-dark">
                  {addonInvoicePreviewData?.previewData?.total}/{addonInvoicePreviewData?.previewData?.interval}
                </div>

              </div>
              {/* Info block */}
              <h6 className="fw-normal mb-2 gapalyze-text-dark mt-3 mx-2" style={{ fontSize: '14px' }}>Subscribing on Gapalyze</h6>
              <ul
                className="mb-2 ps-3 gapalyze-text-muted mx-2"
                style={{ fontSize: '12px', lineHeight: '1.5' }}
              >
                {addonInvoicePreviewData?.previewData?.message?.map((item, index) => (
                  <li
                    key={index}
                    dangerouslySetInnerHTML={{ __html: item }}
                  />
                ))}
              </ul>

              <hr className="my-2" style={{ borderColor: '#dadce0', opacity: 1 }} />

              <p
                className="mb-0 gapalyze-text-muted small px-1"
                style={{ fontSize: '11px', lineHeight: '1.4' }}
                dangerouslySetInnerHTML={{
                  __html: addonInvoicePreviewData?.previewData?.term || ''
                }}
              />
            </div>

            {/* Footer */}

            <div className="modal-footer border-0 px-4 pb-4 pt-1 justify-content-end">
              <button
                className="gapalyze-subscribe-btn px-4 py-2"
                onClick={(e) => handleAddOnSellerAccount(
                  e,
                  addonInvoicePreviewData?.marketplaceAccountId,
                  handleSubmitArgument()
                )}
                disabled={addonInvoicePreviewData?.isLoading}
              >
                {addonInvoicePreviewData?.isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Processing...
                  </>
                ) : <> Continue to Payment </>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddonPreviewModal;